/** @jsx React.DOM */

var React = require('react');
var shallowEqual = require('react/lib/shallowEqual');

module.exports = React.createClass({displayName: 'exports',
	  shouldComponentUpdate: function(nextProps, nextState) {
	    return !shallowEqual(this.props, nextProps) ||
	           !shallowEqual(this.state, nextState);
	  },
	  
	getInitialState: function() {
		return { grade:undefined, text:undefined, dropdownOpen: false }
	},
	
	getDefaultProps: function() {
		return { errors: [] };
	},
	errorFor: function(id) {
		return _.find(this.props.errors, {id: id});
	},
	
	
	componentDidMount: function() {
			$('body').on('click', (function(e) {
				if(!this.isMounted()) return;
				if($(e.target).closest('.dropdown').length) return;
				this.setState({ dropdownOpen: false });
			}).bind(this));
	},
	
	toggleDropdown: function() {
		this.setState({ dropdownOpen: !this.state.dropdownOpen });
		
		return false;
	},
	
	chooseGrade: function(event) {
		this.setState({ grade:$(event.target).text(), dropdownOpen: false });
		return false;
	},
	
	setText: function(event) {
		this.setState({ text:$(event.target).val()});
		return false;
	},
	
	
	valid: function() {
		return this.state.grade !== undefined && !!this.state.text;
	},
	
	handleSubmit: function(event) {
		this.props.onSubmit(this.state.grade, this.state.text);
		return false;
	},
	
	render: function() {
		return (
                React.DOM.div({className: "landing-info"}, 
                    React.DOM.h1(null, "Insert your text."), 
                    React.DOM.p(null, "Copy and paste a text of your choice in the box below. There is a 20,000 word limit—approximately 5 pages."), 
                    React.DOM.div(null, 
                    	this.errorFor("text") && React.DOM.p({className: "errors"}, this.errorFor("text").message), 
                        React.DOM.textarea({className: this.errorFor("text") && 'has-error', placeholder: "Paste your text here", onChange: this.setText})
                    ), 
                    React.DOM.div({className: "dropdown landing-dropdown "+(this.state.dropdownOpen?'open':''), id: "dropdown-grade"}, 
                        React.DOM.a({href: "#", 'data-toggle': "dropdown", onClick: this.toggleDropdown, className: "toggle"}, React.DOM.data(null, this.state.grade || 'SELECT A GRADE'), React.DOM.span(null, "’")), 
                        React.DOM.ul({className: "dropdown-menu"}, 
                        
							_.range(0,13).map((function(i) {
								return React.DOM.li({key: i}, React.DOM.a({href: "#", onClick: this.chooseGrade}, i===0?'K':i));
							}).bind(this))
						
                        )
                    ), 
                    React.DOM.a({href: "#", onClick: this.handleSubmit, className: 'btn-submit ' + (this.valid()?'':'invisible')}, React.DOM.data(null, "SUBMIT"), React.DOM.span(null))
                )
		);
	}
});


//////////////////
// WEBPACK FOOTER
// ./entryform.js
// module id = 93
// module chunks = 0